<template>
  <header>
    <div class="header">
      <div class="header-logo">
        <router-link to="/">
          <img src="/images/logo.png" alt="首页" />
        </router-link>
      </div>
      <div class="header-region">
        <!-- <el-dropdown>
          <span class="el-dropdown-link">
            <em>{{ indexRegion }}</em>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in regions"
              :key="index"
              @click.native="chooseRegion(item.id, item.areaname)"
              >{{ item.names }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown> -->
				<span class="ciytwrap">
					<el-dialog 
					
				:modal-append-to-body='false'
          :visible.sync="dialogVisible"
          width="1000px"
          :show-close='true'
					class="listbox"
          
        >	
          
					<h3>Hi，同学</h3>
					<p>选择你要报考的地区、考试，为您定制学习内容</p>
					<div class="citytitle"> <img  style="width:20px;height:20px" src="/images/dibiao.png" alt="">  报考地区</div>
					<div >
							<span   class="citylist"  :class="{ ciytActive:ciytActiveindex==item.id}" v-for="(item, index) in regions"
              :key="index"
              @click="chooseRegion(item.id,   item.names,index,item.areaname)"
              >{{ item.names }} </span>
					</div>
           <span   @click.stop="closuers"  class="listbox-closure"><img    style="width:30px" src="/images/closure.png" alt=""></span>
        </el-dialog>
				</span>
        

        <el-button class="citylistbumm" type="text" @click="dialogVisible = true"
          >  {{citynametitle}}    <i class="el-icon-arrow-down el-icon--right"></i> </el-button
        >
      </div>
      <div class="header-nav">
        <!-- :class="{active :item.url == $route.path }" -->
        <ul>
          <li @click="open(0)" class="active">题库</li>
            <li @click="open(3)">在线课堂</li>
    
          <li @click="open(2)">网络课堂</li>
          <!-- <li @click="open(3)" :class="listClass">题库</li> -->
        
          <li @click="open(5)">图书商城</li>

          <li @click="open(4)">招录信息</li>
                <li @click="open(1)">莘知官网</li>
        </ul>
      </div>

      <div class="header-right">
        <div class="header-search">
          <!-- <p>
						<i class="el-icon-search"></i>
						<input type="text" placeholder="搜试题，找答案" v-model="searchValue" @keyup.13="search" />
					</p> -->
          <!-- <el-button  class="butt"  type="primary" @click="search">搜索</el-button> -->
          <span @click="search"> <i class="el-icon-search"></i> &nbsp搜题</span>
        </div>

        <div class="header-link" v-if="tokens == ''">
          <button class="header-login" @click="openLogin('login')">登录</button>
          <el-dialog
            :visible.sync="show"
            :append-to-body="true"
            width="400px"
            v-if="show"
            :close-on-click-modal="false"
          >
            <Login
              :loginType="loginType"
              :bindId="bindId"
              v-on:listenLogin="listenLogin"
              @show="onlin"
            ></Login>
          </el-dialog>
          <button class="header-regis" @click="openLogin('regis')">注册</button>
        </div>

        <div class="header-logining" v-else>
          <el-dropdown>
            <p class="el-dropdown-link">
              <img :src="user_image" alt="头像" />
              <em>{{ user_name }}</em>
            </p>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in loginDropdown"
                :key="index"
                @click.native="openUser(index)"
                >{{ item.name }}</el-dropdown-item
              >
              <el-dropdown-item @click.native="exitLogin"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <chat></chat>
    </div>
  </header>
</template>

<script>
import Login from "@/components/Login.vue";
import EventBus from "../eventBus/eventBus";
import chat from "./chat.vue";
export default {
  name: "",
  inject: ["reload"],
  data() {
    return {
      region: "重庆",
      dialogVisible: false,
      regions:[],
      showClo:true,
      headerNav: [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "莘知官网",
          url: "https://www.sz517.com/",
        },
        {
          name: "网络课堂",
          url: "https://www.sz517.com/szwk-wk/",
        },
        {
          name: "在线课堂",
          url: "https://www.sz517.com/zhibo/",
        },
        {
          name: "招录信息",
          url: "https://www.sz517.com/jszp",
        },
        {
          name: "图书商城",
          url: "https://www.sz517.com/ksjc",
        },
      ],
      activeIndex: "0",
      show: false,
      loginType: "",
      tokens: "",
      bindId: "",
			ciytActiveindex:      localStorage.getItem("cityId"),
      loginDropdown: [
        // {
        // 	name: "基本资料",
        // 	url: "/user",
        // },
        {
          name: "错题巩固",
          url: "/user/wrong",
        },
        {
          name: "我的收藏",
          url: "/user/collect",
        },
        {
          name: "我的笔记",
          url: "/user/note",
        },
      ],
      searchValue: "",
      showLogin: "",
      userInfo: {},
      user_id: "",
      user_image: "",
      user_name: "",
      indexRegion: localStorage.getItem("city"),
      citynametitle:localStorage.getItem('citynames'), 
    };
  },
  computed: {},

  methods: {
  
   
    // 获取城市信息
    getCityData() {
      this.$api.getCity().then((res) => {
        // console.log(res)
        for (const iterator in res.data) {
            if(res.data[iterator].areaname === '黑龙江省'){
               res.data[iterator].names  =  '黑龙江'
                continue 
            }
           res.data[iterator].names  =  res.data[iterator].areaname.slice(0,2)
        } 
        console.log(res.data)
        this.regions = res.data;
        






        //console.log("地区")
        if (!localStorage.getItem("idCode")) {
          let num = localStorage.getItem("ip").slice(0, 2) * 10000;
          for (const item in this.regions) {
            if (num == this.regions[item].id) {
              //console.log(num,this.regions[item].id)
              localStorage.setItem("idCode", 2);
              console.log("地区id");
              localStorage.setItem("city", this.regions[item].areaname);
              localStorage.setItem("cityId", this.regions[item].id);
              this.indexRegion = this.regions[item].areaname;
              this.ciytActiveindex = this.regions[item].id
              localStorage.setItem('citynames',this.regions[item].names) 
               this.citynametitle = this.regions[item].names
            }
          }
          //console.log("ip地址")
        }

        // localStorage.setItem("city", '重庆');
        // localStorage.setItem("cityId", '500000');
      });
      // this.$post("city").then((res) => {
      // 	this.regions = res.data;
      // });
    },
    //地区选择
    chooseRegion(id, names,index,areaname) {
      this.ciytActiveindex = id
      //console.log("选中地区")
      localStorage.setItem("city", areaname);
      localStorage.setItem("cityId", id);
      localStorage.setItem('citynames',names)  
      //console.log(id,areaname)
      this.citynametitle = names  
      this.$router.go(0);
    },
    //nav
    open(index) {
      var url = this.headerNav[index].url;
      switch (index) {
        case 0:
          if (this.$route.path == "/") {
            this.$router.go(0);
          } else {
            this.$router.push({
              path: "/",
            });
            this.activeIndex = index;
          }

          break;
        case 1:
          window.open(url, "_blank");
          break;
        case 2:
          window.open(url, "_blank");
          break;
        case 3:
          window.open(url, "_blank");
          break;
        case 4:
          window.open(url, "_blank");
          break;
        case 5:
          window.open(url, "_blank");
          break;
      }
    },
    openLogin(item) {
      this.show = true;
      this.loginType = item;
      this.bindId = localStorage.getItem("UserToken");
    },
    onlin(show) {
      //console.log(show)
      this.show = show;
    },

    //监听子组件的值
    listenLogin(data) {
      this.loginType = data;
      this.show = false;
    },
    openUser(index) {
      var url = this.loginDropdown[index].url;
      this.$router.push({
        path: url,
      });
    },
    search() {
      this.$router.push({
        path: "/searchpage",
      });

      return;
      if (
        localStorage.getItem("UserToken") == "" ||
        !localStorage.getItem("UserToken")
      ) {
        this.$message.error("请先登录");
        return;
      } else {
        if (this.searchValue.trim() == "") {
          this.$message({
            message: "请输入搜索关键字",
            type: "error",
            showClose: true,
          });
        } else {
          if (this.$route.path == "/search") {
            this.$router.push({
              path: "/search",
              query: {
                key: this.searchValue.trim(),
              },
            });
            // this.$link(query);
            this.$router.go(0);
            this.searchValue = "";
          } else {
            this.$router.push({
              path: "/search",
              query: {
                key: this.searchValue,
              },
            });
            this.searchValue = "";
          }
        }
      }
    },
    closuers(){
     this.dialogVisible =false
    },
    // 退出
    exitLogin() {
      localStorage.removeItem("user_id");
      localStorage.setItem("UserToken", "");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_image");
      localStorage.getItem("userInfo") !== null
        ? localStorage.removeItem("userInfo")
        : "";

      this.$router.push("/");
      this.$router.go(0);
      // this.$get("token").then((res) => {
      // 	if (res.code == 200) {
      // 		localStorage.setItem("token", res.data.token);
      // 		this.$router.push("/");
      // 		this.$router.go(0);
      // 	}
      // });
    },
    closeDialog(){
      this.dialogVisible =false
    },
    getcityid() {},
		handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },

  created() {
    this.getCityData();
    this.tokens = localStorage.getItem("UserToken");
    // if (this.tokens == '' || !this.tokens) {
    // 	this.openLogin('login')
    // }else{

    // }

    if (JSON.parse(localStorage.getItem("userInfo"))) {
      let userinfo = JSON.parse(localStorage.getItem("userInfo"));
      this.user_name = userinfo.nickname;
      this.user_image = userinfo.image;
    }

    // if (
    // 	localStorage.getItem("isMobile") &&
    // 	localStorage.getItem("isMobile") == "1"
    // ) {
    // 	this.openLogin("bind");
    // 	localStorage.removeItem("isMobile");
    // }

    EventBus.$on("userName", (res) => {
      //console.log('bus',res)
      this.user_name = res;
    });
    this.getcityid();
  },
  mounted() {},

  components: {
    Login,
    chat,
  },
};
</script>

<style scoped>
/* header */
header {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 20px rgba(34, 45, 50, 0.2);
}

.header {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  line-height: 80px;
}

.header-logo {
  float: left;
}

.header-logo img {
  height: 30px;
  position: relative;
  top: -5px;
}

.header-region {
  float: left;
  margin-left: 10px;
  position: relative;
  cursor: pointer;
}

.butt {
  line-height: 17px;
}

/* .header-region::before {
  content: "";
  display: block;
  width: 1px;
  height: 15px;
  background: #ccc;
  position: absolute;
  left: 0;
  top: 32px;
} */

.header-region .el-dropdown-link {
  color: #333;
  outline: none;
}

.header-region .el-dropdown-link em {
  display: inline-block;
  width: 29px;
  overflow: hidden;
  white-space: nowrap;
  float: left;
  margin-left: 10px;
}

.header-nav {
  margin-left: 30px;
  float: left;
}

.header-nav ul {
  overflow: hidden;
}

.header-nav li {
  float: left;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  color: #333;
  border: none;
  padding: 0 20px;
}

.header-nav .active {
  color: #e60012;
  font-size: 18px;
  font-weight: bold;
}

.header-nav li:hover {
  color: #e60012;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.header-right {
  float: right;
  overflow: hidden;
  cursor: pointer;
  width: 308px;
}

.header-search {
  float: left;
}
.header-search span {
  width: 32px;
  height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #e60012;
  line-height: 26px;
}
.header-link {
  float: left;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form--inline .el-form-item {
  margin-right: 0;
  height: 40px;
  margin-top: 20px;
}

.header-search .el-input__inner {
  border-radius: 0;
  border-color: #e60012;
}

.header .el-button {
  height: 41px;
  border-radius: 0;
  color: #fff;
  border: 1px solid#e60012;
}

.header .el-button span {
  color: #fff;
}

.header-search p {
  display: block;
  width: 256px;
  height: 38px;
  border: 1px solid#e60012;
  position: relative;
  top: 20px;
  float: left;
  line-height: 38px;
  padding: 0 10px 0 30px;
}
.citylistbumm{
  color: #000 !important;
  border:none !important;  
}
.citylist:hover{
  background: #e60012;
  color: white;
}

.header-search p i {
  position: absolute;
  left: 8px;
  line-height: 40px;
  color: #ccc;
  font-size: 16px;
}

.header-search p input {
  border: none;
  width: 100%;
  height: 37px;
  outline: none;
}

.header-link {
  margin-left: 50px;
}

.header-link button {
  font-size: 16px;
  color: #666;
}

.header-link button:hover {
  color: #e60012;
}

.header-link .header-login {
  padding-right: 10px;
  margin-right: 10px;
  position: relative;
}

.header-link .header-login::after {
  content: "";
  display: block;
  width: 1px;
  height: 15px;
  background-color: #ccc;
  position: absolute;
  right: 0;
  top: 5px;
}

.header-logining {
  float: right;
  margin-left: 50px;
}

.header-logining img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.header-logining em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
  float: right;
  margin-left: 5px;
  color: #666;
}
.citylist {
  display: inline-block;
  width: 100px;
  height: 40px;
  text-align: center;
  line-height: 40px;

	border: 0.5px solid rgb(184, 173, 173);
	border-radius: 5px;
	margin: 20px 20px  0 20px;
}
.ciytlist{
	color: #000  !important
}
.citybox button{
	color: #000  !important
}
.listbox h3{
	font-size: 22px !important;
    font-weight: bold;
    position: relative;
    color: #393f47 !important;
    
	padding-left: 40px !important;
	padding-top: 60px;
	line-height: 40px !important;

}
.listbox-closure{
  position: absolute;
top: -10px;
left: 948.6px;
}
.listbox p{
	font-size: 14px;
	line-height: 40px !important;
color: #60656b;
	padding-left: 40px !important;

}
.listbox div{
	color: #393f47;
margin-left: 6px;

}
.citytitle{
	padding-left: 40px !important;
	font-size: 16px !important;
}
.ciytActive{
	background: #e60012;
	color: rgb(245, 245, 245);
	font-weight: bold;
}


</style>
